module.exports = __webpack_public_path__ + "img/26.cc60c7b.webp";